<template>
    <div class="w-full text-[#2b2b2b] p-[16px]">
        <div class="mb-4 flex items-center justify-between">
            <h2 class="text-4xl">Gestion des offres</h2>
            <AddJobView />
        </div>
        <div class="bg-white rounded-lg px-4 py-6 mb-3 text-[#2b2b2b]">
            <h2 class="underline">Liste des offres</h2>
            <div class="w-full">
                <div v-if="jobs.length == 0" class="flex flex-col items-center justify-center h-[70vh]">
                    <span  class="font-light">Auncune offre</span>
                </div>
                <div v-else class="grid grid-cols-4 gap-6 mt-6 overflow-y-scroll">
                    <div v-for="(job, index) in jobs" :key="index" class="border rounded-3xl p-6 inline-flex flex-col w-full">
                        <div class="flex items-center justify-between">
                            <span class="size-14 rounded-full bg-[#f5f5f5] flex items-center justify-center"><BriefcaseBusiness color="#8c8c8c" strokeWidth="1.2" size="18"/></span>
                            <UpdateJobView :jobData="job"/>
                        </div>
                        <h3 class="text-2xl px-1 mt-4 font-light">{{ job.title }}</h3>
                        <p class="text-xl text-[#939698] px-1 mt-1 font-light line-clamp-2">{{ job.description }}</p>
                        <div class="mt-3">
                            <span class="rounded-full h-10 bg-[#f6f6f6] text-[#7a7a7a] p-3 text-xl font-extralight inline-flex items-center gap-x-2">
                                <TimerReset strokeWidth="1.6" size="16"/>
                                Temps plein
                            </span>
                        </div>
                        <div class="flex items-center justify-between mt-3">
                            <div class="flex items-center gap-x-2 font-extralight text-[12px] px-1">
                                <CalendarDays strokeWidth="1.6" size="16"/>
                                {{ dateFormat(job.created_at) }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import toast from '@/components/ui/toast';
import AddJobView from '@/views/navigation/add-job-view.vue';
import UpdateJobView from '@/views/navigation/update-job-View.vue';
import API from '@/service/API';
import {BriefcaseBusiness,TimerReset,CalendarDays} from "lucide-vue-next";
export default {
    name: 'JobView',
    components:{
        AddJobView,
        UpdateJobView,
        CalendarDays,
        TimerReset,
        BriefcaseBusiness
    },
    data() {
        return {
            isload: true,
            jobs: [],
        };
    },
    mounted() {
        this.getAllOffers();
    },
    methods: {
        getAllOffers(){
            API.get("jobs")
            .then((response)=>{
                if(response.data.status){
                    this.jobs = response.data.data;
                }
            })
            .catch()
            .finally(()=>{
                this.isload = false;
            });
        },
        applianceOffer(){
            // const data = {user_id:3,job_id:1,status:'en attente'}
        },
        dateFormat(dateString){
            const date = new Date(dateString);
            const options = {
                day: "numeric",
                month: "long",
                year: "numeric",
            };
            const formattedDate = date.toLocaleDateString("fr-FR", options);
            const parts = formattedDate.split(' ');
            const day = parts[0];
            const month = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
            const year = parts[2];
            const finalFormattedDate = `${day} ${month}, ${year}`;
            return finalFormattedDate;
        }
    }
};
</script>